// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tc-cursor-item > .tc-util-btn{width:100%;height:100%;padding:0;box-sizing:border-box}\n", ""]);
// Exports
module.exports = exports;
